import { SubPages } from '../../components/sub-pages.tsx';
import { ActivityPage } from './activity.tsx';
import { EmbedPage } from './embed.tsx';
import { TeamPage } from './team.tsx';

export function SettingsSection() {
  return (
    <SubPages
      title="Settings"
      section="settings"
      pages={[
        {
          id: 'embed',
          title: 'Embed',
          summary:
            'Put the assistant in your product: the sites it may appear on, your keys, and the code to paste with them filled in.',
          Component: EmbedPage,
        },
        {
          id: 'team',
          title: 'Team',
          summary: 'Who on your team can open this console, and what each person may change.',
          Component: TeamPage,
        },
        {
          id: 'activity',
          title: 'Activity',
          summary:
            "Every change to this vendor's setup, newest first: who made it, when and what changed.",
          Component: ActivityPage,
        },
      ]}
    />
  );
}
